module.exports = __webpack_public_path__ + "static/media/animation4.0f1a9595.jpg";